import FeedbackEndOfTherapyThankYouPage from './FeedbackEndOfTherapyThankYouPage'

export default FeedbackEndOfTherapyThankYouPage
